// Well... this works, but unless we create separate form handlers for each
// domain that point to our . Or we figure out how to get Pardot to actually
// redirect to our success_location and error_location urls, we can't communicate
// to find out if it was actually successful.
// We could just fire and forget and not confirm it actually worked.
// Maybe that isn't a bad idea. If it passes client validation, then it should be working.

import qs from 'qs'

const defaultOptions = {
  timeout: 5000,
  messageId: null,
  checkResponse: false,
}

export function generateMessageId() {
  return `pardotmessage_${Date.now()}_${Math.ceil(Math.random() * 100000)}`
}

function clearMessageHandler(messageHandler) {
  window.removeEventListener('message', window[messageHandler], true)
}

function removeIframe(iframe) {
  if (iframe && iframe.parentNode) {
    iframe.parentNode.removeChild(iframe)
  }
}

function getIframeDocument(iframe) {
  return (
    (iframe.contentWindow && iframe.contentWindow.document) ||
    iframe.contentDocument.document ||
    iframe.contentDocument
  )
}

function fetchPardot(url, formData, options = {}) {
  const timeout = options.timeout || defaultOptions.timeout
  const checkResponse = options.checkResponse || defaultOptions.checkResponse

  let timeoutId
  let intervalId

  return new Promise((resolve, reject) => {
    const messageId = options.messageId || generateMessageId()
    const messageHandler = '__pardotHandler_' + messageId

    window[messageHandler] = event => {
      if (!event.data) {
        return
      }
      if (typeof event.data !== 'object') {
        return
      }
      if (event.data.messageId !== messageId) {
        return
      }
      resolve({
        ok: true,
        json: () => Promise.resolve(formData),
      })
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      clearMessageHandler(messageHandler)
    }
    window.addEventListener('message', window[messageHandler], true)

    const iframe = document.createElement('iframe')
    iframe.setAttribute('height', '0')
    iframe.setAttribute('width', '0')
    iframe.setAttribute('style', 'border: 0')
    document.getElementsByTagName('body')[0].appendChild(iframe)
    const iframeDocument = getIframeDocument(iframe)

    const pardotURL =
      url +
      '?' +
      qs.stringify(formData, { arrayFormat: 'repeat' }) +
      '&message_id=' +
      encodeURIComponent(messageId) +
      '&signup_url=' +
      encodeURIComponent(window.location.href)

    const metaRefresh = iframeDocument.createElement('meta')
    metaRefresh.setAttribute('http-equiv', 'refresh')
    metaRefresh.setAttribute('content', `0;URL='${pardotURL}'`)
    iframeDocument.getElementsByTagName('head')[0].appendChild(metaRefresh)

    let leftDomain = false
    intervalId = setInterval(function() {
      try {
        const currentIframeDocument = getIframeDocument(iframe)
        if (currentIframeDocument.domain === document.domain) {
          if (leftDomain && currentIframeDocument.readyState === 'complete') {
            // we're here when the child window returned to our domain
            clearInterval(intervalId)
            alert('returned: ' + currentIframeDocument.URL)
            if (!iframe.contentWindow) {
              // console.log('no content window?')
            }
            iframe.contentWindow.postMessage({ message: 'requestResult' }, '*')
          }
        } else {
          // this code should never be reached,
          // as the x-site security check throws
          // but just in case
          leftDomain = true
        }
      } catch (e) {
        // we're here when the child window has been navigated away or closed
        if (iframe.contentWindow && iframe.contentWindow.closed) {
          clearInterval(intervalId)
          clearTimeout(timeoutId)
          resolve({
            ok: true,
            json: () => Promise.resolve({ formData }),
          })
          return
        }
        if (!checkResponse) {
          // fire and forget
          clearInterval(intervalId)
          clearTimeout(timeoutId)
          resolve({
            ok: true,
            json: () => Promise.resolve({ formData }),
          })
          return
        }
        // navigated to another domain
        leftDomain = true
      }
    }, 500)

    timeoutId = setTimeout(() => {
      clearInterval(intervalId)
      reject(new Error(`Pardot request to ${url} timed out`))
      clearMessageHandler(messageHandler)
      removeIframe(iframe)
      window[messageHandler] = () => {
        clearMessageHandler(messageHandler)
      }
    }, timeout)
  })
}

export default fetchPardot
